import { ContentByIdsEndpoint } from '@/docs-partials/clips';
import * as React from 'react';
export default {
  ContentByIdsEndpoint,
  React
};